/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on the home page
                // window.onbeforeunload = function() {
                //     window.scrollTo(0, 0);
                // };
                window._animations.global.setup();

                // Get page title
                var pageTitle = $("title").text();
                var offPageTitle = $('#off-page-title-holder').data('title');

                    // Change page title on blur
                $(window).blur(function() {
                    $("title").text(offPageTitle);
                });

                    // Change page title back on focus
                $(window).focus(function() {
                    $("title").text(pageTitle);
                });

                var footerNewsletter = $('.j-footer-newsletter');
                footerNewsletter.on('click','.pg-footer--newsletter--toggle', function(){
                    if(!footerNewsletter.hasClass('active')){
                        footerNewsletter.addClass('active');
                        $(this).fadeOut();
                        footerNewsletter.find('.wpcf7-submit').slideDown();
                        footerNewsletter.find('[name="email-address"]').focus();
                    }
                });



                document.addEventListener( 'wpcf7mailsent', function( event ) {

                    if(event.detail.contactFormId === "6748"){
                        eventName = "cf7Submission__contact";
                    } else if(event.detail.contactFormId === "8604") {
                        eventName = "cf7Submission__social-media-content-campaign";
                    } else if(event.detail.contactFormId === "8706") {
                        eventName = "cf7Submission__social-media-strategy-campaign";
                    } else {
                        eventName = "cf7Submission__newsletter";
                    }
                    window.dataLayer.push({
                    "event" : eventName,
                    "formId" : event.detail.contactFormId,
                    "response" : event.detail.inputs
                    });
                });


                // var splashLottie = $('.j-splash--lottie');
                // lottieObject = lottie.loadAnimation({
                //     container: splashLottie.get(0), // the dom element that will contain the animation
                //     renderer: 'svg',
                //     loop: true,
                //     autoplay: true,
                //     path: splashLottie.data('animation-path')
                // });
                // lottieObject.addEventListener('DOMLoaded',function(){
                //    splashLottie.addClass('animation--playing');
                // });
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
                window._menu.setup(); //
                // $('select').niceSelect();


                $('.j-anchor').on('click', function() {
                    var anchor = $(this).data('anchor');

                    var offset = 0;

                    if ($(window).width() > 800) {
                        offset = 100;
                    }
                    $("html, body").animate({ scrollTop: $(anchor).offset().top + offset }, 500);
                });


                // Custom Select
                $('select').niceSelect();
                $('.nice-select').on('click',function() {
                    var i = $(this);
                    $(".nice-select").not(i).removeClass("custom-open");
                    i.toggleClass("custom-open");
                    if( i.hasClass("custom-open") ){
                        i.find(".option");
                        i.find(".focus").removeClass("focus");
                        i.find(".selected").addClass("focus");
                    } else {
                        i.focus();
                    }
                });

                var lottieObject;
                $('.j-lottie').each(function(){
                    var _this = $(this);
                    lottieObject = lottie.loadAnimation({
                        container: _this.get(0), // the dom element that will contain the animation
                        renderer: 'svg',
                        loop: true,
                        autoplay: false,
                        path: _this.data('animation-path')
                    });
                    (function(obj, container) {
                        obj.addEventListener('DOMLoaded',function(){
                            if(container.data('animation-start') >= 0){
                                var segment = [container.data('animation-start'), container.data('animation-end')];
                                obj.playSegments( segment, true );

                                if(container.data('animation-delay') >= 0){
                                    obj.pause();
                                    setTimeout(function(){
                                          obj.playSegments( segment, true );
                                    }, container.data('animation-delay') );
                                }
                            }else{
                                obj.play();
                            }
                        });
                    })(lottieObject, _this);

                });
            }
        },
        // Home page
        'home': {
            init: function() {},
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // Page animations
                window._animations.home.setup();


            }
        },
        // About page
        'page_template_template_about': {
            init: function() {},
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // Page animations
                window._animations.aboutus.setup();


            }
        },
        // Home page
        'page_template_template_dan': {
            init: function() {},
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                // Page animations
                window._animations.dan.setup();

	            $('.j-carousel').slick({
	                arrows: true,
	                dots: false,
	                centerMode: true,
	                centerPadding: '100px',
	                slidesToShow: 2,
	                slidesToScroll: 1,
	                variableWidth: true,
	                responsive: [
	                    {
	                        breakpoint: 1101,
	                        settings: {
		                        variableWidth: false,
		                        slidesToShow: 2,
	                        }
	                    },
	                    {
	                        breakpoint: 975,
	                        settings: {
	                            centerPadding: '50px',
	                        }
	                    },
	                    {
	                        breakpoint: 768,
	                        settings: {
	                            centerPadding: '35px',
	                            slidesToShow: 1,
	                        }
	                    },
	                ]
	            });

                $('.pg-google-map').each(function(){
                    map = window._map.new_map( $(this) );
                }); //

            }
        },
        // Office page
        'page_template_template_office': {
            init: function() {
                window._animations.office.setup();
            },
            finalize: function() {
                $('.pg-google-map').each(function(){
                    map = window._map.new_map( $(this) );
                }); //
            }
        },
        // Contact page
        'page_template_template_contact': {
            init: function() {
            },
            finalize: function() {
                window._animations.contact.setup();
            }
        },
        // Archive
        'post_type_archive': {
            init: function() {
                window._animations.work.setup();
             },
            finalize: function() {

            }
        },
        // Blog page
        'blog': {
            init: function() {
                window._animations.blog.setup();
            },
            finalize: function() {

            }
        },
        // Category page
        'category': {
            init: function() {
               window._animations.blog.setup();
            },
            finalize: function() {

            }
        },
        // Single post
        'single_post': {
            init: function() {
               window._animations.single.setup();
            },
            finalize: function() {

            }
        },
        // Services page
        'single_service': {
            init: function() {
               window._animations.service.setup();
            },
            finalize: function() {

            }
        },

        // Social Campaign 1
        'page_template_template_social': {
            init: function() {
                window._animations.socialCampaign1.setup();
            },
            finalize: function() {
            }
        },

        // Social Campaign 2
        'page_template_template_social2': {
            init: function() {
                window._animations.socialCampaign1.setup();
                window._animations.socialCampaign2.setup();
            },
            finalize: function() {
            }
        },

        // Careers Page
        'page_template_template_careers': {
            init: function() {

                $(window).load(function(){
                    window._animations.careers.setup();
                });

                var careers = $('.j-careers');
                careers.on('click','.j-job--toggle', function(){
                    var _this = $(this);
                    var job = _this.parents('.j-job');
                    if (job.hasClass('j-job__open')){
                        job.find('.j-job--body').slideUp();
                        job.removeClass('j-job__open');
                    }else{
                        job.find('.j-job--body').slideDown();
                        job.addClass('j-job__open');
                    }
                });

                var scroller = $(".j-scrollbar");


                scroller.liMarquee({
                    circular: true,
                    hoverStop: true,
                    scrollAmount: 10,
                    startShow : true
                });
                $('.j-scrollbar--prev').on('mouseenter',function(){
                    scroller.liMarquee('changeOptions', {direction:'right', scrollAmount: 30} );
                }).on('mouseleave',function(){
                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 10} );
                });
                $('.j-scrollbar--next').on('mouseenter',function(){

                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 30} );
                }).on('mouseleave',function(){

                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 10} );
                });

            }
        },

        // Internal Porjects Page
        'page_template_template_internal_projects': {
            init: function() {

                $(window).load(function(){
                    window._animations.internalProjects.setup();
                });

                var scroller = $(".j-scrollbar");


                scroller.liMarquee({
                    circular: true,
                    hoverStop: true,
                    scrollAmount: 10,
                    startShow : true
                });
                $('.j-scrollbar--prev').on('mouseenter',function(){
                    scroller.liMarquee('changeOptions', {direction:'right', scrollAmount: 30} );
                }).on('mouseleave',function(){
                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 10} );
                });
                $('.j-scrollbar--next').on('mouseenter',function(){

                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 30} );
                }).on('mouseleave',function(){

                    scroller.liMarquee('changeOptions', {direction:'left', scrollAmount: 10} );
                });

            }
        },

        // Home page
        'post_type_archive_project': {
            init: function() {},
            finalize: function() {

            }
        },

        'error404': {
            init: function() {},
            finalize: function() {
                window._quiz.setup();
            }
        },
        'single_project': {
            init: function() {},
            finalize: function() {
                window._animations.caseStudy.setup();
            }
        },
        'author': {
            init: function() {},
            finalize: function() {
                window._animations.author.setup();
            }
        }
    };


    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },


        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                console.log('fire this classname' + classnm);
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }

    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.